import React, { Component } from "react";
import IntroSection from "components/intro-section/IntroSection";

const format = (title) => {
  let arr = [];
  let exludeWords = ["e", "di"];
  arr = title.split("-");
  return arr
    .map((word, i) => {
      return exludeWords.includes(word) && i !== 0
        ? [word]
        : word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

export default class MaiaTaqa extends Component {
  render() {
    return (
      <div id="single-document">
        <IntroSection
          category={format(this.props.match.url.split("/")[1])}
          subsector={format(this.props.match.url.split("/")[2])}
          subsubsector={format(this.props.match.url.split("/")[4])}
        />
        <div className="pad-mobile">
          <iframe
            style={{ width: "100%", height: "70vh" }}
            src="http://eventi.utilitalia.it/maia-taqa.htm"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    );
  }
}
